/** @jsxImportSource @emotion/react */
import React from "react";
import { colors } from "../../../../../components/colors";
import { DetailsRow } from "../../../../../components/DetailsRow";
import { formatMoneyAmount } from "../../../../../util";
import { OrderLine } from "../../../model/OrderSuccessResponse";
import { css } from "@emotion/react";

interface OrderProductLinesProps {
  orderLines: OrderLine[];
}

const additionLineStyle = css`
  margin-left: 16px;
`;

const additionToAdditionLineStyle = css`
  margin-left: 32px;
`;

export const OrderProductLines = ({ orderLines }: OrderProductLinesProps) => {
  return (
    <>
      {orderLines?.map((ol) => (
        <React.Fragment key={ol.id}>
          <DetailsRow
            leftText={`${ol.amount}X ${ol.description}`}
            rightText={formatMoneyAmount(
              ol.totalPrice.amount,
              ol.totalPrice.currency
            )}
            leftTextColor={colors.textPrimary}
          />
          {ol?.lines?.map((additionLine) => (
            <React.Fragment key={additionLine.id}>
              <DetailsRow
                additionalStyles={additionLineStyle}
                key={additionLine.id}
                leftText={`${additionLine.amount}X ${additionLine.description}`}
                rightText={formatMoneyAmount(
                  additionLine.totalPrice.amount,
                  additionLine.totalPrice.currency
                )}
                rightTextColor={colors.textSecondary}
              />
              {additionLine?.lines?.map((al) => (
                <DetailsRow
                  additionalStyles={additionToAdditionLineStyle}
                  key={al.id}
                  leftText={`${al.amount}X ${al.description}`}
                  rightText={formatMoneyAmount(
                    al.totalPrice.amount,
                    al.totalPrice.currency
                  )}
                  rightTextColor={colors.textSecondary}
                />
              ))}
            </React.Fragment>
          ))}
        </React.Fragment>
      ))}
    </>
  );
};
